module.exports = __webpack_public_path__ + "static/media/jessica-maria-dos-santos.84fde283.jpg";